var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "quiz__pressure" }, [
    _c("div", { staticClass: "tonometer__wrapper" }, [
      _c("div", { staticClass: "tonometer img" }, [
        _c("img", {
          attrs: {
            src: _vm.mediaBaseUrl + "quiz/tonometer/tonometer.svg",
            alt: "tonometer"
          }
        })
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "arrow",
        style: { transform: "translateX(-50%) rotate(" + _vm.angle + "deg)" },
        attrs: {
          src: _vm.mediaBaseUrl + "quiz/tonometer/arrow.svg",
          alt: "arrow"
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "quiz__options" },
      _vm._l(_vm.options, function(option) {
        return _c(
          "div",
          {
            key: option.text,
            staticClass: "option",
            class: { option_active: _vm.value === option.text },
            on: {
              click: function() {
                return _vm.handleSelect(option)
              }
            }
          },
          [
            _c("div", { staticClass: "option__text" }, [
              _vm._v(_vm._s(option.text))
            ])
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }